// Shared home for the requirement-reference sentinel prefixes, so a display/validation path that
// doesn't know which field it's looking at (JsonPrettyView, validatePolicyForm) can still
// recognize a group or named location requirement reference without guessing. Each domain
// (groupRequirement.util.js, namedLocationRequirement.util.js) owns its own prefix and
// isRequirementRef/getRequirementId/toRequirementRef built from it; this file only combines the
// two prefixes for the generic case.
export const GROUP_REQUIREMENT_REF_PREFIX = 'group:'
export const LOCATION_REQUIREMENT_REF_PREFIX = 'location:'

const ALL_REQUIREMENT_REF_PREFIXES = [GROUP_REQUIREMENT_REF_PREFIX, LOCATION_REQUIREMENT_REF_PREFIX]

export const isAnyRequirementRef = (value) =>
  typeof value === 'string' && ALL_REQUIREMENT_REF_PREFIXES.some((prefix) => value.startsWith(prefix))

export const getAnyRequirementId = (value) => {
  if (typeof value !== 'string') {
    return null
  }
  const prefix = ALL_REQUIREMENT_REF_PREFIXES.find((p) => value.startsWith(p))
  return prefix ? value.slice(prefix.length) : null
}
